import { ts_hocsinh_lichsu_yte_donvitinh } from '../models/response/category/ts_hocsinh_lichsu_yte_donvitinh';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

export const DON_VI_TINH_THUOC_API_END_POINT = "don-vi-tinh-thuoc";

export const donViTinhThuocApi = {
    // Lấy tất cả đơn vị tính thuốc
    selectAll: () => apiGuestClient.get(`${DON_VI_TINH_THUOC_API_END_POINT}`),

    // Lấy chi tiết đơn vị tính thuốc theo ID
    detail: (id: number) => apiClient.get(`${DON_VI_TINH_THUOC_API_END_POINT}/${id}`),

    // Thêm mới đơn vị tính thuốc
    insert: (data: ts_hocsinh_lichsu_yte_donvitinh) => apiClient.post(`${DON_VI_TINH_THUOC_API_END_POINT}`, data),

    // Cập nhật đơn vị tính thuốc
    update: (data: ts_hocsinh_lichsu_yte_donvitinh) => apiClient.put(`${DON_VI_TINH_THUOC_API_END_POINT}`, data),

    // Xóa đơn vị tính thuốc
    delete: (id: number) => apiClient.delete(`${DON_VI_TINH_THUOC_API_END_POINT}/${id}`),
};
